
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.037 12.001a2.11 2.11 0 001.67-2.08 2.132 2.132 0 00-4.264 0c0 1.047.755 1.915 1.75 2.091a2.707 2.707 0 00-2.302 2.674v1.101h5.554v-1.101c0-1.382-1.07-2.52-2.408-2.685zM16.106 12.001a2.108 2.108 0 001.667-2.08 2.133 2.133 0 00-4.265 0c0 1.047.76 1.915 1.755 2.091a2.703 2.703 0 00-2.298 2.674v1.101h5.554v-1.101c0-1.382-1.076-2.52-2.413-2.685zM10.328 4.323a2.116 2.116 0 001.677-2.079 2.13 2.13 0 00-4.258 0c0 1.046.741 1.914 1.737 2.09-1.302.197-2.316 1.317-2.316 2.674V8.06h5.554V7.008c0-1.382-1.057-2.52-2.394-2.685zM15.942 7.335h1.113c-.436-2.657-2.157-4.793-4.572-5.728V2.8c1.69.847 3.064 2.361 3.46 4.535zM6.93 14.258v1.2c.966.352 1.84.544 2.823.544.952 0 1.765-.179 2.731-.507v-1.193c-.725.386-1.765.603-2.73.603-1.001 0-1.858-.233-2.824-.647zM7.17 2.72V1.541c-2.416.866-4.229 2.898-4.755 5.554h1.127C4.016 4.922 5.48 3.501 7.17 2.72z","fill":"#333"}})])
          )
        }
      }
    